import { addOrUpdateMedications, fetchMedicationsApi } from 'api/api-manager';
import { days } from 'consts';
import React, { useEffect, useState } from 'react'
import Checkbox from 'react-custom-checkbox';
import SearchIcon from '../../../assets/img/icons/Search.svg'
import ArrowDown from '../../../assets/img/icons/arrow-down.svg'

function MedicationForm({ patient, editMedication, closeModal }) {
    const isEditMode = editMedication?.id;
    const [medication, setMedication] = useState(editMedication);
    const [showDosageOptions, setShowDosageOptions] = useState();
    const [medicationOptions, setMedicationOptions] = useState([]);
    const [dosageOptions, setDosageOptions] = useState([]);

    useEffect(() => {
        fetchMedicationOptions();
    }, [medication.name]);

    useEffect(() => {
        dosageOptions?.includes(medication.dosage) ? setShowDosageOptions(false) : setShowDosageOptions(true)
    }, [medication.dosage, dosageOptions]);

    async function fetchMedicationOptions() {
        if (!medication?.name) return;
        const res = await fetchMedicationsApi(medication?.name);
        const [resultCount, medicationNames, medicationDosages] = res;
        setMedicationOptions(medicationNames || []);
        if (medicationNames?.includes(medication.name)) {
            setMedicationOptions([]);
            setDosageOptions(medicationDosages?.STRENGTHS_AND_FORMS?.[0] || []);
        }
    }

    const updateMedication = (medicationKey, val) => {
        setMedication((prev) => ({ ...prev, [medicationKey]: val }));
    };

    const addReminder = () => {
        const initialReminder = { time: '00:00', days: '' };
        const reminders = [...medication.reminders, initialReminder];
        updateMedication('reminders', reminders);
    };

    const updateEveryDay = (reminderIndex) => {
        const reminderDays = medication?.reminders?.[reminderIndex]?.days;
        const days = reminderDays?.length === 7 ? '' : '1234567';
        let reminders = medication?.reminders?.map((r, i) =>
            i === reminderIndex ? { ...r, days } : r,
        );
        updateMedication('reminders', reminders);
    };

    const getSortedDays = (days) => {
        const sortedDays = days?.split('')?.sort((a, b) => +a - +b);
        return sortedDays?.join('');
    };

    const handleClickDay = (reminderIndex, day) => {
        let days = medication?.reminders?.[reminderIndex]?.days;
        days?.includes(day) ? (days = days.replace(day, '')) : (days += day);
        let reminders = medication?.reminders?.map((r, i) =>
            i === reminderIndex ? { ...r, days: getSortedDays(days) } : r,
        );
        updateMedication('reminders', reminders);
    };

    const handleChoseTime = (reminderIndex, time) => {
        let reminders = medication?.reminders?.map((r, i) =>
            i === reminderIndex ? { ...r, time } : r,
        );
        updateMedication('reminders', reminders);
    };

    const onSelectDosage = (option) => {
        updateMedication('dosage', option)
        setShowDosageOptions(false)
    }

    const saveMedication = async () => {
        try {
            await addOrUpdateMedications(patient.id, [medication], isEditMode);
        } catch (error) {
            console.log('error saveMedication', error);
        }
        closeModal()
    };

    return (
        <div className='wrap-medication-form'>
            <p className='medication-form-title'>Adding medication</p>
            <form className='medication-form'>
                <div className='form-group'>
                    <span className='label'>Add your medication</span>
                    <input onInput={(e) => updateMedication('name', e.target.value)} className='form-control name-input' value={medication?.name} />
                    <span className='input-icon'><img src={SearchIcon} alt='search' /></span>
                    {medicationOptions.length > 0 &&
                        <ul className='api-options'>
                            {medicationOptions.map(op => <li onClick={() => updateMedication('name', op)}>{op}</li>)}
                        </ul>
                    }
                </div>
                <div className='form-group'>
                    <span className='label'>Dosage</span>
                    <input onInput={(e) => updateMedication('dosage', e.target.value)} className='form-control dosage-input' value={medication?.dosage} />
                    <span onClick={() => setShowDosageOptions(!showDosageOptions)
} className='input-icon'><img className={`${showDosageOptions && 'arrow-up'}`} src={ArrowDown} alt='search' /></span>
                    {dosageOptions.length > 0 && showDosageOptions &&
                        <ul className='api-options'>
                            {dosageOptions.map(op => <li onClick={() => onSelectDosage(op)}>{op}</li>)}
                        </ul>
                    }
                </div>
                <p className='medication-form-title'>Reminders<small className='text-black'>Reminder will show in mobile app only</small></p>
                {medication.reminders?.length > 0 &&
                    medication.reminders?.map((r, i) =>
                        <div key={i} className='reminder'>
                            <input onInput={(e) => handleChoseTime(i, e.target.value)} type='time' value={r.time} />
                            <div className='every-day'>
                                <Checkbox
                                    containerClassName='m-0'
                                    className='medications-every-radio'
                                    checked={r.days?.length === 7}
                                    onChange={() => updateEveryDay(i)}
                                    borderColor="#707070"
                                    borderWidth={2}
                                    borderRadius={100}
                                    size={20}
                                    label={'Every day'}
                                    key={i} />
                            </div>
                            <div className='reminder-days'>
                                {[1, 2, 3, 4, 5, 6, 7].map((d) =>
                                    <span key={d} onClick={() => handleClickDay(i, d)} className={`reminder-day ${r?.days?.includes(d) && 'selected'}`}>{days[d]}</span>
                                )}
                            </div>
                        </div>
                    )
                }
                <span className='add-reminder' onClick={addReminder}>+ Add reminder</span>
            </form>
            <div className="modal-footer p-0">
                <button
                    className="btn cancel-btn"
                    type="button"
                    onClick={() => closeModal()}>Cancel</button>

                <button
                    className="btn save-btn"
                    type="button"
                    onClick={saveMedication}>Save</button>
            </div>
        </div>
    )
}

export default MedicationForm